import { render, staticRenderFns } from "./showDetail.vue?vue&type=template&id=39a7ac7b&scoped=true&"
import script from "./showDetail.vue?vue&type=script&lang=js&"
export * from "./showDetail.vue?vue&type=script&lang=js&"
import style0 from "./showDetail.vue?vue&type=style&index=0&id=39a7ac7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a7ac7b",
  null
  
)

export default component.exports